import React from 'react';

import SignIn from '../pages/SignIn';
import RootPublic from './RootPublic';

import '../css/sideMenu.css';
import { useAuth } from '../hooks/auth';
import RootAuthenticated from './RootAuthenticated';

const Root: React.FC = () => {
  const { dataConnection } = useAuth();
  const { token } = dataConnection;
  const localToken = localStorage.getItem('@LiveChat:token');
  let auth = false;

  if (token || localToken) {
    auth = true;
  }

  return auth ? <RootAuthenticated /> : <SignIn />;
};

export default Root;
